import { memo } from 'react';

function TodoItem({ tache, changerEtat, supprimerTache }) {
  return (
    <li>
      <input
        type="checkbox"
        id={`tache-${tache.id}`}
        checked={tache.terminee}
        onChange={() => changerEtat(tache.id)}
      />
      <label htmlFor={`tache-${tache.id}`} style={tache.terminee ? { textDecoration: 'line-through' } : {}}>
        {tache.texte}
      </label>
      <button
        onClick={() => supprimerTache(tache.id)}
        aria-label={`Supprimer la tâche : ${tache.texte}`}
      >
        ✕
      </button>
    </li>
  );
}
export default memo(TodoItem, (prevProps, nextProps) => {
  return prevProps.tache === nextProps.tache; 
});